<template>
  <div class="app-page promotions b-modal bulma-dropdown">
    <vue-headful title="ALICE | Promotions"></vue-headful>
    <div class="column-wrapper">
      <div class="master-column white-bg">
        <div class="columns no-margin head-label">
          <div class="column no-padding">
            <label class="label no-margin">Promotions</label>
            <div class="select mr-1">
              <select v-model="language" @change="selectPromotion">
                <option v-for="lang in languageOptions" :key="lang.value" :value="lang.value">
                  {{ lang.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="column no-padding is-narrow">
            <div
              class="button is-small is-info"
              @click="canAddNewPromotion"
              :disabled="detailMode === 'add'"
            >
              <font-awesome-icon icon="plus"></font-awesome-icon>
              <span>&nbsp;Add</span>
            </div>
          </div>
          <div class="column no-padding is-narrow">
            <b-dropdown aria-role="list" position="is-bottom-left">
              <div class="button is-small is-white" slot="trigger" role="button">
                <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
              </div>
              <b-dropdown-item
                aria-role="listitem"
                class="collection-menu-item"
                @click="toggleModalImportPromotion(true)"
              >
                  <span class="icon">
                    <font-awesome-icon icon="file-import"></font-awesome-icon>
                  </span>
                <span>Import promotion</span>
              </b-dropdown-item>
              <b-dropdown-item
                aria-role="listitem"
                class="collection-menu-item"
                @click="exportPromotion()"
              >
                  <span class="icon">
                    <font-awesome-icon icon="file-export"></font-awesome-icon>
                  </span>
                <span>Export promotion</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <b-loading :is-full-page="true" :active="isExportPromotionLoading"></b-loading>
          <div class="modal import-promotion-modal" :class="{'is-active' : isModalImportPromotionActive}">
            <div class="modal-background"></div>
            <div class="modal-content">
              <div class="card no-margin">
                <div class="card-title">Import Promotion</div>
                <div class="columns is-mobile card-form">
                  <div class="column">
                    <div class="field field-left">
                      <label class="label">Promotion file ( .xls/.xlsx)</label>
                      <div class="control is-expanded" :class="{'is-loading-file' : isImportPromotionLoading}">
                        <b-field v-if="!isImportPromotionLoading" class="file is-primary"
                                 :class="{'has-name': !!promotionFile}">
                          <b-upload v-model="promotionFile" class="file-label" :accept="acceptPromotionPreset">
                              <span class="file-cta">
                                  <b-icon class="file-icon" icon="upload"></b-icon>
                                  <span class="file-label">Browse file</span>
                              </span>
                            <span class="file-name" v-if="promotionFile">
                                  {{ promotionFile.name }}
                              </span>
                          </b-upload>
                        </b-field>
                        <b-loading :is-full-page="false" :active="isImportPromotionLoading"></b-loading>
                      </div>
                      <p style="color: red" v-if="importPromotionError">{{ importPromotionError }}</p>
                    </div>
                  </div>
                </div>
                <div class="card-action">
                  <button
                    class="button is-info"
                    @click="importPromotion"
                    :disabled="!promotionFile || isImportPromotionLoading"
                  >Import
                  </button>
                  <button
                    class="button is-info is-inverted"
                    @click="toggleModalImportPromotion(false)"
                    :disabled="isImportPromotionLoading"
                  >Cancel
                  </button>
                </div>
              </div>
            </div>
            <button
              class="modal-close is-large"
              aria-label="close"
            ></button>
          </div>

        </div>
        <div class="input-wrapper">
          <div class="field">
            <div class="control has-icons-left is-expanded">
              <input
                type="text"
                class="input is-small"
                placeholder="Filter from title, or campaign..."
                @change="selectPromotion"
                v-model.trim="searchInput"
                :disabled="detailMode === 'add'"
              />
              <span class="icon is-small is-left">
                <font-awesome-icon icon="filter"></font-awesome-icon>
              </span>
            </div>
          </div>
          <div class="block" id="promotion-type-filter">
            <b-radio v-model="promotionTypeSelected"
                     v-for="type in promotionType"
                     :key="type.name"
                     :name="type.label"
                     :native-value="type.name"
            >
              {{ type.label }}
            </b-radio>
          </div>
        </div>
        <div class="table-wrapper">
          <table class="table is-narrow is-fullwidth">
            <colgroup>
              <col span="1" style="width: 70%;"/>
              <col span="1" style="width: 25%;"/>
              <col span="1" style="width: 5%;"/>
            </colgroup>
            <tbody>
            <tr
              v-for="promotion in filteredPromotionList"
              :key="promotion.id"
              :class="{
                  'is-active-row': promotion.id === selectedPromotionId,
                  'disabled-row': detailMode === 'add'
                }"
              @click="selectPromotion(promotion)"
            >
              <td class="message-column">
                  <span
                    class="status-icon"
                    :class="{
                      'has-text-success': isActivePromotion(promotion.startDate, promotion.endDate)
                    }"
                  >
                    <font-awesome-icon icon="circle"></font-awesome-icon>&nbsp;
                  </span>
                <div>{{ promotion.title }}</div>
              </td>
              <td class="has-text-right">
                <div
                  class="tag is-rounded"
                  v-if="promotion.campaign"
                >{{ promotion.campaign || '&nbsp;' }}
                </div>
              </td>
              <td class="tool-column has-text-right">
                <font-awesome-icon
                  icon="caret-right"
                  v-show="selectedPromotionId !== promotion.id"
                ></font-awesome-icon>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="detail-column white-bg">
        <div
          class="column-wrapper"
          v-if="detailMode === 'add' || (editingPromotion && editingPromotion.id)"
        >
          <div class="left-column">
            <div class="columns no-margin subhead-label">
              <div class="column no-padding">
                <label class="label no-margin">
                  <span v-if="detailMode === 'edit'">Edit promotion detail</span>
                  <span v-else-if="detailMode === 'add'">Add promotion detail</span>
                </label>
              </div>
            </div>
            <div class="form-wrapper">
              <div class="field">
                <label for="edit-title-input" class="label">Title *</label>
                <input
                  id="edit-title-input"
                  class="input"
                  v-model="editingPromotion.title"
                  placeholder="Promotion title"
                  @change="toggleEditDirty(true)"
                  :class="{'is-danger': !editingPromotion.title}"
                />
              </div>
              <div class="field">
                <label for="edit-subtitle-input" class="label">Subtitle</label>
                <textarea
                  id="edit-subtitle-input"
                  class="input"
                  v-model="editingPromotion.subtitle"
                  placeholder="Promotion subtitle"
                  @change="toggleEditDirty(true)"
                  rows="10"
                  cols="50"
                >
                </textarea>
              </div>
              <div class="field">
                <label for="edit-image-input" class="label">Thumbnail Image URL</label>
                <input
                  id="edit-image-input"
                  class="input"
                  v-model="editingPromotion.thumbnailImage"
                  placeholder="Promotion image"
                  @change="toggleEditDirty(true)"
                />
              </div>
              <div class="columns" id="table-buttons-head">
                <div class="column">
                  <div class="field">
                    <label class="label">
                      <span>Buttons ({{ buttonLimit }})</span>
                    </label>
                  </div>
                </div>
                <div class="column">
                  <button v-if="buttonLimit > 0" class="btn btn-light btn-sm" type="button" @click="addButton">
                    <i class="fa fa-plus-circle" aria-hidden="true"></i> Add
                  </button>
                </div>
              </div>
              <div v-if="buttons.length > 0" id="table-buttons">
                <table class="table table-borderless">
                  <thead>
                  <tr>
                    <th>Label</th>
                    <th>URL</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- <tr v-show="!buttons.length">
                    <td class="text-align-right">No data</td>
                  </tr> -->
                  <tr v-for="(info, idx) in buttons" :key="idx">
                    <td>
                      <div class="input-group input-group-sm">
                        <input type="text" class="form-control"
                               aria-describedby="edit-additional-name-input"
                               v-model="info.label"
                               @input="toggleEditDirty(true)">
                      </div>
                    </td>
                    <td>
                      <div class="input-group input-group-sm">
                        <input type="text" class="form-control"
                               aria-describedby="edit-additional-value-input"
                               v-model="info.url"
                               @input="toggleEditDirty(true)">
                        <div class="input-group-append">
                          <button class="btn btn-sm btn-danger" type="button"
                                  @click="removeButton(info.label, idx)">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div class="field">
                <label for="edit-btn-label-input" class="label">Button Label</label>
                <input
                  id="edit-btn-label-input"
                  class="input"
                  v-model="editingPromotion.buttonLabel"
                  placeholder="Enter button label"
                  @change="toggleEditDirty(true)"
                />
              </div>
              <div class="field">
                <label for="edit-btn-url-input" class="label">Button URL</label>
                <input
                  id="edit-btn-url-input"
                  class="input"
                  v-model="editingPromotion.buttonUrl"
                  placeholder="Enter button url"
                  @change="toggleEditDirty(true)"
                />
              </div> -->
              <div class="break-line"></div>
              <div class="field">
                <label for="edit-campaign-input" class="label">Campaign Name</label>
                <input
                  id="edit-campaign-input"
                  class="input"
                  v-model="editingPromotion.campaign"
                  placeholder="Enter campaign name"
                  @change="toggleEditDirty(true)"
                />
              </div>
              <div class="columns no-bottom-margin">
                <div class="column">
                  <div class="field calendar-input">
                    <label class="label">Promotion Start</label>
                    <div class="control is-expanded has-icons-left">
                      <datetime
                        :max-datetime="editingPromotion.endDate"
                        type="datetime"
                        input-class="input small-date-input"
                        v-model="editingPromotion.startDate"
                        @close="toggleEditDirty(true)"></datetime>
                      <span class="icon is-small is-left">
                        <font-awesome-icon icon="calendar-alt"></font-awesome-icon>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field calendar-input">
                    <label class="label">Promotion End</label>
                    <div class="control is-expanded has-icons-left">
                      <datetime
                        :min-datetime="editingPromotion.startDate"
                        type="datetime"
                        input-class="input small-date-input"
                        v-model="editingPromotion.endDate"
                        @close="toggleEditDirty(true)"
                      ></datetime>
                      <span class="icon is-small is-left">
                        <font-awesome-icon icon="calendar-alt"></font-awesome-icon>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label">
                  <span>Promotion status:&nbsp;</span>
                  <strong
                    class="has-text-success"
                    v-if="isActivePromotion(editingPromotion.startDate, editingPromotion.endDate)"
                  >Active</strong>
                  <strong class="inactive-status" v-else>Inactive</strong>
                </label>
              </div>
              <div class="break-line"></div>
              <div class="columns" id="additional-info-head">
                <div class="column">
                  <div class="field">
                    <label class="label">
                      <span>Additional Information</span>
                    </label>
                  </div>
                </div>
                <div class="column">
                  <button class="btn btn-light btn-sm" type="button" @click="addNewAdditionalInfoRow">
                    <i class="fa fa-plus-circle" aria-hidden="true"></i> Add
                  </button>
                </div>
              </div>
              <!-- Table : Additional -->
              <div id="additional-info">
                <!-- <div class="card-header">
                  <div class="field" style="float: right;">
                    <div class="input-group-append">
                      <button class="btn btn-light btn-sm" type="button" @click="addNewAdditionalInfoRow" :disabled="isDuplicateKey">
                        <i class="fa fa-plus-circle" aria-hidden="true"></i> Add
                      </button>
                    </div>
                  </div>
                </div> -->
                <div>
                  <table class="table table-borderless">
                    <thead>
                    <tr>
                      <th>Name</th>
                      <th>Value</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-show="!convertedAdditionalInfoList.length">
                      <td class="text-align-right">No data</td>
                    </tr>
                    <tr v-for="(info, idx) in convertedAdditionalInfoList" :key="idx">
                      <td>
                        <div class="input-group input-group-sm">
                          <!-- <div class="input-group-prepend">
                            <span class="input-group-text" id="edit-additional-name-input">name</span>
                          </div> -->
                          <input type="text" class="form-control"
                                 aria-describedby="edit-additional-name-input"
                                 v-model="info.key"
                                 @input="toggleEditNameInfo(info.key)"
                                 :disabled="info.isSave">
                        </div>
                      </td>
                      <td>
                        <div class="input-group input-group-sm">
                          <!-- <div class="input-group-prepend">
                            <span class="input-group-text" id="edit-additional-value-input">value</span>
                          </div> -->
                          <input type="text" class="form-control"
                                 aria-describedby="edit-additional-value-input"
                                 v-model="info.value"
                                 @input="toggleEditValueInfo(true)">
                          <div class="input-group-append">
                            <button class="btn btn-sm btn-danger" type="button"
                                    @click="removeAdditionalInfoRow(info.key, idx)">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <!-- <div class="card-footer">
                  <div class="field">
                    <div class="btn-group" role="group">
                      <button
                        v-if="(!editNameInfo && !editValueInfo) || isDuplicateKey"
                        type="button"
                        class="btn btn-primary btn-sm"
                        :disabled="!editNameInfo"
                        @click="applyChanges"
                      >
                        Apply changes
                      </button>

                      <button
                        v-else
                        type="button"
                        class="btn btn-primary btn-sm has-badge-rounded has-badge-danger"
                        :disabled="isDuplicateKey"
                        @click="applyChanges"
                        data-badge
                      >
                        Apply changes
                      </button>

                    </div>
                    <span class="duplicate-text" v-show="isDuplicateKey">
                      Duplicated Name
                    </span>
                  </div>
                </div> -->
              </div>

            </div>
          </div>
          <div class="right-column">
            <div class="LySlider slider-disable-max-width">
              <div class="lyInner">
                <flex-bubble-layout :data="previewData"></flex-bubble-layout>
              </div>
            </div>
          </div>
        </div>
        <div class="column-footer">
          <div
            class="columns is-mobile"
            v-if="detailMode === 'edit' && editingPromotion && editingPromotion.id"
          >
            <div class="column">
              <div class="button is-danger is-inverted" @click="confirmDeletePromotion">Delete</div>
            </div>
            <div class="column" align="right">
              <button
                v-if="editDirty && !isDuplicateKey"
                class="button is-primary has-badge-rounded has-badge-danger"
                @click="saveEditeditingPromotion"
                data-badge
              >
                <span class="icon">
                  <font-awesome-icon icon="save"></font-awesome-icon>
                </span>
                <span>Save</span>
              </button>
              <button
                v-else
                class="button is-primary"
                :disabled="isDuplicateKey"
                @click="saveEditeditingPromotion"
              >
                <span class="icon">
                  <font-awesome-icon icon="save"></font-awesome-icon>
                </span>
                <span>Save</span>
              </button>
            </div>
          </div>
          <div class="columns is-mobile" v-if="detailMode === 'add'">
            <div class="column">
              <div class="button is-danger is-inverted"
                   @click="confirmCancelAddPromotion">
                Cancel
              </div>
            </div>
            <div class="column" align="right">
              <button class="button is-primary" @click="doneAddPromotion">
                <span>Finish</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="download-area"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import flexBubbleLayout from '../components/Logs/Line/FlexBubbleLayout.vue';
import alice from '../alice-api';

const defaultButtonLimit = 3;
export default {
  name: 'promotions',
  components: {
    'flex-bubble-layout': flexBubbleLayout,
  },
  data() {
    return {
      searchInput: '',
      selectedPromotionId: '',
      language: 'TH',
      detailMode: 'edit',
      editDirty: false,
      editingPromotion: {},
      testTable: [1, 2, 3, 4, 5],
      additionalInfo: {},
      convertedAdditionalInfoList: [],
      isDuplicateKey: false,
      editNameInfo: false,
      editValueInfo: false,
      promotionType: [{
        name: 'all',
        label: 'All',
      }, {
        name: 'campaign',
        label: 'Campaign',
      }, {
        name: 'non-campaign',
        label: 'Non campaign',
      }],
      promotionTypeSelected: 'all',
      filteredPromotions: [],
      buttons: [],
      buttonLimit: defaultButtonLimit,
      isModalImportPromotionActive: false,
      isImportPromotionLoading: false,
      importPromotionError: null,
      isExportPromotionLoading: false,
      promotionFile: null,
      acceptPromotionPreset: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
      languageOptions: [
        { name: 'Thai', value: 'TH' },
        { name: 'English', value: 'EN' },
      ]
    };
  },
  mounted() {
    this.getPromotion({ activeOnly: false }).then(() => {
      this.selectFirstPromotion();
    });
  },
  methods: {
    ...mapActions({
      getPromotion: 'promotion/getPromotion',
      createNewPromotion: 'promotion/createNewPromotion',
      updatePromotion: 'promotion/updatePromotion',
      deletePromotion: 'promotion/deletePromotion',
    }),
    selectFirstPromotion() {
      if (this.language !== 'TH' && this.language !== 'EN') {
        this.language = 'TH';
      }
      if (this.promotionList && this.promotionList[0]) {
        for (let i = 0; i < this.promotionList.length; i += 1) {
          if (this.promotionList[i].language === this.language) {
            this.selectPromotion(this.promotionList[i]);
            break;
          }
        }
      }
    },
    selectPromotion(promotionObj) {
      const languaselect = this.language;
      this.editDirty = false;
      // this.editNameInfo = false;
      this.isDuplicateKey = false;
      if (promotionObj) {
        if (promotionObj.id === undefined) {
          for (let i = 0; i < this.promotionList.length; i += 1) {
            if (this.promotionList[i].language === this.language) {
              this.selectedPromotionId = this.promotionList[i].id;
              this.editingPromotion = JSON.parse(JSON.stringify(this.promotionList[i]));
              break;
            }
          }
        } else {
          this.selectedPromotionId = promotionObj.id;
          this.editingPromotion = JSON.parse(JSON.stringify(promotionObj));
        }
        this.convertedAdditionalInfoList = this.convertAdditionalInformation();
        this.buttonLimit = defaultButtonLimit;
        this.buttons = this.convertPromotionButtonsData();
      }
      this.language = languaselect;
    },
    toggleEditDirty(state) {
      this.editDirty = state;
    },
    saveEditeditingPromotion() {
      if (!this.isDuplicateKey) {
        this.applyChanges();
      }
      this.updatePromotion({
        promotionId: this.selectedPromotionId,
        data: this.editingPromotion,
      })
        .then(() => {
          this.editDirty = false;
          this.setPromotionData(this.selectedPromotionId, this.editingPromotion);
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Promotion updated.',
            position: 'is-bottom',
            duration: 3000,
          });
        })
        .catch((e) => {
          if (e.response.status === 500) {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Update failed, some required field is missing.',
              position: 'is-bottom',
              duration: 3000,
            });
          } else {
            // console.log(e.response);
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Update failed, unknown error occured.',
              position: 'is-bottom',
              duration: 3000,
            });
          }
        });
    },
    setPromotionData(id, data, isDelete) {
      let targetIndex = -1;
      for (let i = 0; i < this.promotionList.length; i += 1) {
        if (this.promotionList[i].id === id) {
          targetIndex = i;
          if (data) {
            const newData = JSON.parse(JSON.stringify(data));
            Vue.set(this.promotionList, i, newData);
          }
          break;
        }
      }
      if (isDelete && targetIndex > -1) {
        this.promotionList.splice(targetIndex, 1);
      }
      return targetIndex;
    },
    confirmDeletePromotion() {
      this.$buefy.dialog.confirm({
        title: 'Removing promotion',
        message: 'Are you sure to remove this promotion?',
        cancelText: 'Cancel',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deletePromotion({ promotionId: this.selectedPromotionId }).then(() => {
            this.$buefy.toast.open({
              type: 'is-success',
              message: 'Promotion deleted.',
              position: 'is-bottom',
              duration: 3000,
            });
            this.setPromotionData(this.selectedPromotionId, null, true);
            this.selectFirstPromotion();
          });
        },
      });
    },
    canAddNewPromotion() {
      const languaselect = this.language;
      // Check if edit dirty
      if (this.editDirty) {
        this.$buefy.dialog.confirm({
          title: 'Discard changes',
          message: 'You have unsaved changes, do you want to discard those changes?',
          cancelText: 'Keep editing',
          confirmText: 'Discard',
          type: 'is-warning',
          hasIcon: true,
          onConfirm: () => {
            this.editDirty = false;
            this.addNewPromotion();
          },
        });
      } else {
        this.addNewPromotion();
      }
      this.language = languaselect;
    },
    confirmCancelAddPromotion() {
      this.$buefy.dialog.confirm({
        title: 'Removing promotion',
        message: 'Are you sure to remove this unsaved promotion?',
        cancelText: 'Keep it',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.detailMode = 'edit';
          this.selectFirstPromotion();
        },
      });
    },
    addNewPromotion() {
      this.selectedPromotionId = '';
      this.editingPromotion = {
        language: '',
        title: '',
        subtitle: '',
        thumbnailImage: '',
        buttonLabel: '',
        buttonUrl: '',
        campaign: '',
        startDate: '',
        endDate: '',
        additionalInformation: {},
      };
      this.detailMode = 'add';
      this.convertedAdditionalInfoList = [];
      this.buttons = [];
      this.buttonLimit = defaultButtonLimit;
    },
    doneAddPromotion() {
      if (!this.isDuplicateKey) {
        this.applyChanges();
      }
      this.editingPromotion.language = this.language;
      this.createNewPromotion({
        data: this.editingPromotion,
      }).then((newId) => {
        this.detailMode = 'edit';
        this.selectedPromotionId = '';
        this.editDirty = false;
        this.getPromotion({ activeOnly: false }).then(() => {
          if (newId) {
            this.selectedPromotionId = newId.id;
            this.editingPromotion = JSON.parse(JSON.stringify(newId));
          }
        });
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'New promotion added.',
          position: 'is-bottom',
          duration: 3000,
        });
      });
    },
    isActivePromotion(start, end) {
      const now = moment();
      let hasStart = false;
      let hasEnd = false;
      let startObj = null;
      let endObj = null;
      if (typeof start === 'string' && start.length > 0) {
        try {
          startObj = moment(start);
          if (startObj.isValid()) {
            hasStart = true;
          }
        } catch (e) {
          // console.log('Cannot parse start');
        }
      }
      if (typeof end === 'string' && end.length > 0) {
        try {
          endObj = moment(end);
          if (endObj.isValid()) {
            hasEnd = true;
          }
        } catch (e) {
          // console.log('Cannot parse end');
        }
      }
      // No both = always valid
      if (!hasStart && !hasEnd) {
        return true;
      }
      // No start just end
      if (!hasStart && hasEnd) {
        const diff = now.diff(endObj);
        if (diff > 0) return false;
        return true;
      }
      // No end just start
      if (hasStart && !hasEnd) {
        const diff = now.diff(startObj);
        if (diff >= 0) return true;
        return false;
      }
      // Has both - check in range
      if (hasStart && hasEnd) {
        const diff1 = now.diff(startObj);
        if (diff1 >= 0) {
          const diff2 = endObj.diff(now);
          if (diff2 > 0) {
            return true;
          }
        }
        return false;
      }
      // console.log('OH HELL NO');
      return false;
    },
    // Additional Information
    convertAdditionalInformation() {
      const additionalInformation = { ...this.editingPromotion.additionalInformation };
      const convertedData = [];
      // eslint-disable-next-line guard-for-in
      for (const info in additionalInformation) {
        convertedData.push({
          key: info,
          value: additionalInformation[info],
          isSave: true,
        });
      }
      return convertedData;
      // this.convertedAdditionalInfoList = [...convertedData];
    },
    addNewAdditionalInfoRow() {
      this.convertedAdditionalInfoList.push({ key: null, value: null, isSave: false });
    },
    removeAdditionalInfoRow(removeKey, index) {
      this.toggleEditDirty(true);
      this.convertedAdditionalInfoList.splice(index, 1);
      // remove additionalInformation in editingPromotion by key (data from api)
      const dataUpdated = Object.keys(this.editingPromotion.additionalInformation).reduce((obj, key) => {
        if (key !== removeKey) {
          // eslint-disable-next-line no-param-reassign
          obj[key] = this.editingPromotion.additionalInformation[key];
        }
        return obj;
      }, {});
      this.editingPromotion.additionalInformation = { ...dataUpdated };
      this.toggleEditNameInfo(removeKey);
    },
    applyChanges() {
      this.editNameInfo = false;
      this.editValueInfo = false;
      // change status to save
      for (const data of this.convertedAdditionalInfoList) {
        if (data.key) {
          data.isSave = true;
        }
      }
      this.updateAdditionalInfo(this.convertedAdditionalInfoList);
      this.updateButtons();
    },
    updateAdditionalInfo(dataForUpdate) {
      // update existing Information
      if (this.editingPromotion.additionalInformation) {
        for (const data of dataForUpdate) {
          // check existing key
          for (const key of Object.keys(this.editingPromotion.additionalInformation)) {
            if (data.key === key) {
              this.editingPromotion.additionalInformation[key] = data.value;
              break;
            }
          }
        }
      } else {
        // add additionalInformation key
        for (const data of dataForUpdate) {
          const keyData = data.key;
          this.editingPromotion.additionalInformation = {};
          this.editingPromotion.additionalInformation[keyData] = data.value;
        }
      }
      // add new info using compare existingInfo and dataForUpdate
      const existingInfo = this.convertAdditionalInformation();
      const differenceInfoList = dataForUpdate.filter(this.comparer(existingInfo));
      if (differenceInfoList.length > 0) {
        for (const info of differenceInfoList) {
          this.editingPromotion.additionalInformation[info.key] = info.value;
        }
      }
    },
    comparer(otherArray) {
      return (current) => otherArray.filter((other) => other.key === current.key).length === 0;
    },
    toggleEditValueInfo(state) {
      this.editValueInfo = state;
      this.toggleEditDirty(true);
    },
    toggleEditNameInfo(nameInfoInput) {
      this.toggleEditDirty(true);
      let duplicateKeyInExistingInfo = false;
      // find existing keys in editingPromotion (data from api)
      const existingKeys = this.editingPromotion.additionalInformation ? Object.keys(this.editingPromotion.additionalInformation) : {};
      if (existingKeys.length > 0) {
        if (existingKeys.includes(nameInfoInput)) {
          duplicateKeyInExistingInfo = true;
        }
      }

      // if has existing keys
      if (duplicateKeyInExistingInfo) {
        this.isDuplicateKey = true;
        this.editNameInfo = false;
      } else {
        // if it does not have existing keys, find existing keys in convertedAdditionalInfoList
        const convertedAdditionalInfoListForSort = [...this.convertedAdditionalInfoList];
        // sort data by key to find duplicate keys
        const sortedAdditionalInfoList = convertedAdditionalInfoListForSort.sort((a, b) => {
          const keyA = a.key;
          const keyB = b.key;
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });
        const results = [];
        for (let i = 0; i < sortedAdditionalInfoList.length - 1; i += 1) {
          if (sortedAdditionalInfoList[i + 1].key === sortedAdditionalInfoList[i].key) {
            results.push(sortedAdditionalInfoList[i].key);
          }
        }
        if (results.length > 0) {
          this.isDuplicateKey = true;
          this.editNameInfo = false;
        } else {
          this.isDuplicateKey = false;
          this.editNameInfo = true;
        }
      }
    },
    searchPromotionList(promotions) {
      const filtered = [];
      if (this.searchInput) {
        for (let i = 0; i < promotions.length; i += 1) {
          const p = promotions[i];
          const title = (p.title != null) ? p.title.toLowerCase() : '';
          const campaign = (p.campaign != null) ? p.campaign.toLowerCase() : '';
          if (title.indexOf(this.searchInput.toLowerCase()) > -1 || campaign.indexOf(this.searchInput.toLowerCase()) > -1) {
            filtered.push(p);
          }
        }
        return filtered;
      }
      return promotions;
    },
    filterPromotionListByType(promotions) {
      const filtered = [];
      const isThai = this.language === 'TH';
      const isEnglish = this.language === 'EN';
      if (this.promotionTypeSelected !== 'all') {
        const isCampaign = this.promotionTypeSelected === 'campaign';
        if (isCampaign) {
          for (let i = 0; i < promotions.length; i += 1) {
            if ((promotions[i].campaign && promotions[i].campaign !== '') && (isEnglish && promotions[i].language === 'EN')) {
              filtered.push(promotions[i]);
            } else if ((promotions[i].campaign && promotions[i].campaign !== '') && (isThai && promotions[i].language === 'TH')) {
              filtered.push(promotions[i]);
            }
          }
        } else {
          for (let i = 0; i < promotions.length; i += 1) {
            if ((!promotions[i].campaign || promotions[i].campaign === '') && isEnglish && promotions[i].language === 'EN') {
              filtered.push(promotions[i]);
            } else if ((!promotions[i].campaign || promotions[i].campaign === '') && isThai && promotions[i].language === 'TH') {
              filtered.push(promotions[i]);
            }
          }
        }
      } else if (isEnglish) {
        for (let i = 0; i < promotions.length; i += 1) {
          if (promotions[i].language === 'EN') {
            filtered.push(promotions[i]);
          }
        }
      } else if (isThai) {
        for (let i = 0; i < promotions.length; i += 1) {
          if (promotions[i].language === 'TH') {
            filtered.push(promotions[i]);
          }
        }
      }
      return filtered;
    },
    addButton() {
      if (this.buttonLimit > 0) {
        this.buttons.push(
          {
            label: null,
            url: null,
            isSave: false,
          },
        );
        this.buttonLimit -= 1;
      }
    },
    removeButton(label, index) {
      if (this.buttons.length > 0) {
        this.toggleEditDirty(true);
        this.buttons.splice(index, 1);
        this.buttonLimit += 1;
      }
    },
    updateButtons() {
      if (this.buttons.length > 0) {
        this.editingPromotion.buttonLabel = null;
        this.editingPromotion.buttonUrl = null;
        this.editingPromotion.buttonLabel2 = null;
        this.editingPromotion.buttonUrl2 = null;
        this.editingPromotion.buttonLabel3 = null;
        this.editingPromotion.buttonUrl3 = null;
        for (let i = 0; i < this.buttons.length; i += 1) {
          const button = this.buttons[i];
          this.editingPromotion[`buttonLabel${i === 0 ? '' : i + 1}`] = button.label;
          this.editingPromotion[`buttonUrl${i === 0 ? '' : i + 1}`] = button.url;
          button.isSave = true;
        }
      }
    },
    convertPromotionButtonsData() {
      const {
        buttonLabel, buttonUrl, buttonLabel2, buttonUrl2, buttonLabel3, buttonUrl3,
      } = this.editingPromotion;
      const convertedData = [];
      if (buttonLabel && buttonUrl) {
        convertedData.push(
          {
            label: buttonLabel,
            url: buttonUrl,
            isSave: true,
          },
        );
      }
      if (buttonLabel2 && buttonUrl2) {
        convertedData.push(
          {
            label: buttonLabel2,
            url: buttonUrl2,
            isSave: true,
          },
        );
      }
      if (buttonLabel3 && buttonUrl3) {
        convertedData.push(
          {
            label: buttonLabel3,
            url: buttonUrl3,
            isSave: true,
          },
        );
      }
      this.buttonLimit -= convertedData.length;
      return convertedData;
    },
    toggleModalImportPromotion(isActive) {
      this.isModalImportPromotionActive = isActive;
      if (!isActive) {
        this.importPromotionError = null;
      }
    },
    importPromotion() {
      this.isImportPromotionLoading = true;
      this.importPromotionError = null;
      const formData = new FormData();
      formData.append('file', this.promotionFile);
      alice.importPromotion(formData)
        .then(async () => {
          this.promotionFile = null;
          this.isImportPromotionLoading = false;
          this.isModalImportPromotionActive = false;
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Promotion imported.',
            position: 'is-bottom',
            duration: 3000,
          });
          // get new promotion list
          this.getPromotion({ activeOnly: false }).then(() => {
            this.selectFirstPromotion();
          });
        })
        .catch((error) => {
          this.importPromotionError = error.response.data.data;
          this.promotionFile = null;
          this.isImportPromotionLoading = false;
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Promotion import failed.',
            position: 'is-bottom',
            duration: 3000,
          });
        });
    },
    exportPromotion() {
      this.isExportPromotionLoading = true;
      alice.exportPromotion(this.language ? this.language.toUpperCase().trim() : null, this.promotionTypeSelected)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          const elem = document.getElementById('download-area');
          link.href = url;
          link.setAttribute('download', 'export_promotions.xlsx');
          elem.innerHTML = '';
          elem.appendChild(link);
          link.click();
          this.isExportPromotionLoading = false;
        })
        .catch(() => {
          // console.log(e, e.response);
          this.isExportPromotionLoading = false;
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'An error occurred, cannot export collection data.',
            position: 'is-bottom',
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      promotionList: 'promotion/promotionList',
    }),
    filteredPromotionList() {
      let promotions = this.filteredPromotions.length > 0 ? this.filteredPromotions : this.promotionList;
      if (promotions && promotions.length > 0) {
        promotions = this.searchPromotionList(promotions);
        promotions = this.filterPromotionListByType(promotions);
      } else {
        promotions = [];
      }
      return promotions;
    },
    previewData() {
      const defaultPlaceHolder = 'https://bulma.io/images/placeholders/1280x960.png';
      if (this.editingPromotion) {
        return {
          hero: {
            type: 'image',
            url: this.editingPromotion.thumbnailImage || defaultPlaceHolder,
            size: 'full',
            aspectRatio: '1:1',
            aspectMode: 'fit',
            action: {
              type: 'uri',
              uri: this.editingPromotion.buttonUrl,
            },
          },
          body: {
            type: 'box',
            layout: 'vertical',
            margin: 'lg',
            spacing: 'sm',
            contents: [
              {
                type: 'text',
                text: this.editingPromotion.title,
                weight: 'bold',
                wrap: true,
                size: 'xl',
              },
              {
                type: 'box',
                layout: 'vertical',
                margin: 'lg',
                spacing: 'sm',
                contents: [
                  {
                    type: 'box',
                    layout: 'baseline',
                    spacing: 'sm',
                    contents: [
                      {
                        type: 'text',
                        text: this.editingPromotion.subtitle,
                        color: '#aaaaaa',
                        wrap: true,
                        size: 'sm',
                        flex: 1,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          footer: {
            type: 'box',
            layout: 'vertical',
            spacing: 'sm',
            contents: [
              {
                type: 'button',
                style: 'link',
                height: 'sm',
                action: {
                  type: 'uri',
                  label: this.editingPromotion.buttonLabel,
                  uri: this.editingPromotion.buttonUrl,
                },
              },
            ],
            flex: 0,
          },
        };
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/line-flex.css';

.promotions {
  text-align: left;

  .head-label {
    padding: 0.8rem 0.8rem 0.4rem 0.8rem;
  }

  .subhead-label {
    padding-bottom: 0.8rem;
  }

  .head-label,
  .subhead-label {
    .label {
      font-size: 1.2rem;
      line-height: 1.4rem;
    }

    .no-padding {
      padding: 0;
    }
  }

  .has-text-success {
    color: #44a344 !important;
    margin-right: 10px;
  }

  .master-column {
    display: flex;
    flex-direction: column;

    .input-wrapper {
      padding: 0.4rem 0.8rem 0.8rem 0.8rem;
    }

    .table-wrapper {
      display: flex;
      border-width: 1px 0;
      border-color: #ddd;
      border-style: solid;
      overflow-y: auto;
      overflow-x: hidden;

      td {
        font-size: 0.8rem;
        line-height: 2.4rem;
      }

      .message-column {
        padding-left: 0.9rem;
        display: flex;

        div {
          white-space: nowrap;
          width: 18rem;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .tool-column {
        padding-right: 0.9rem;
      }

      .is-active-row {
        height: 20%;
        background-color: #006cb5;
        color: #fff;
      }

      .disabled-row {
        background-color: #f0f0f0;
        color: #ccc;
        pointer-events: none;

        .tag {
          color: #ccc;
        }
      }

      .status-icon {
        color: #ddd;
        margin-right: 10px;
      }
    }
  }

  .detail-column {
    display: flex;
    flex-direction: column;

    .column-wrapper {
      flex: 1 1 auto;
      flex-direction: row;
      margin: 0;
      padding: 0;

      .left-column,
      .right-column {
        margin: 0;
        padding: 0;
        height: 100%;
        flex: 0 0 50%;
        flex-direction: column;
        display: flex;
      }

      .left-column {
        overflow: hidden;
        padding: 0.8rem;

        .form-wrapper {
          overflow-x: hidden;
          overflow-y: auto;
          flex: 1 1 auto;
          flex-direction: column;
          display: flex;
        }

        .field {
          .label {
            font-size: 0.8rem;
          }

          .input {
            font-size: 0.8rem;
          }

          .no-bottom-margin {
            margin-bottom: 0;
          }
        }

        .calendar-input {
          .icon {
            height: 1.7rem;
          }
        }

        .inactive-status {
          color: #888;
        }

        .break-line {
          border-bottom: 1px solid #ddd;
          margin: 1em 0 1.5em 0;
        }
      }

      .right-column {
        padding: 0.5rem;
        background-color: #555;
        align-items: center;
        justify-content: space-around;
      }
    }

    .column-footer {
      border-top: 1px solid #ddd;
      padding: 0.8rem;
    }
  }

  .slider-disable-max-width {
    max-width: 100%;
    overflow-x: hidden;

    .lyInner {
      overflow-x: hidden;
    }
  }
}

.form-control.is-invalid {
  background-image: none !important;
}

#additional-info {
  table {
    td:nth-child(odd) input {
      border-radius: 5px;
    }

    td:nth-child(even) input {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  }
}

#additional-info-head {
  margin-bottom: 0;

  .column:nth-child(2) {
    display: flex;
    justify-content: flex-end;
  }
}

.duplicate-text {
  color: red;
  margin-left: 7px;
}

// .has-badge-danger {
//   background: #f44336;
// }
#table-buttons-head {
  margin-bottom: 0;

  .column:nth-child(2) {
    display: flex;
    justify-content: flex-end;
  }
}

#edit-subtitle-input {
  height: 100px;
}

.collection-menu-item {
  padding: 5px;

  .icon {
    display: inline-block;
    padding: 0 10px;
    width: 32px;

    svg {
      vertical-align: bottom;
    }
  }
}

.import-promotion-modal {
  .card {
    border-radius: 3px;
    padding: 20px;

    .card-title {
      font-size: 1.25rem;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
    }

    .card-form {
      margin: 10px 0 20px 0;

      .column {
        padding: 0;

        .field-left {
          margin-right: 10px;
        }

        .field-right {
          margin-left: 10px;
        }
      }

      .label {
        color: #305cbb;
      }
    }

    .card-action {
      text-align: right;

      .button {
        margin-left: 10px;
      }
    }

    .label {
      margin-bottom: 25px;
    }

    .control.is-loading-file {
      height: 50px;
    }
  }
}
</style>
